import { RouterStore } from 'react-router-mobx'

export default new RouterStore()
